var map = {
	"./baidu.svg": "/ES5",
	"./bilibili-fill.svg": "KhGE",
	"./bilibili.svg": "NcBN",
	"./bing.svg": "X/SC",
	"./chaoxing.png": "oJFK",
	"./chaoxing.svg": "W1Ec",
	"./doge.png": "Almo",
	"./douban.svg": "pFjW",
	"./duckduckgo.svg": "u5/L",
	"./ecosia.svg": "bP27",
	"./google.svg": "Nr7m",
	"./shejiaotubiao-10.svg": "gcGU",
	"./taobao.svg": "/CC2",
	"./zhihu.svg": "Rgg5",
	"./zhihu_1.svg": "Lyxy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DXRL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search-engines ^\.\/.*$
// module id = DXRL
// module chunks = 1